import { useState, useEffect, useRef } from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import images from "../images/images.js";
import { HeadLogo } from "../components/headLogo.jsx";
import { ModeIndication } from "../components/modeIndication.jsx";

function TravelInfoView({ location, onNext, title, label,  mode }) {
  const [currentPeriod, setCurrentPeriod] = useState(null);
  const [details, setDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [sliderRef, keenInstanceRef] = useKeenSlider({
    loop: true,
    initial: 0,
    detailsChanged(s) {
      setDetails(s.track.details);
      const rel = s.track.details.rel;
      setCurrentPeriod(location[rel]);
    },
  });

  // Scroll to correct item when label is provided
  useEffect(() => {
    if (!label || !keenInstanceRef?.current || !location.length) return;

    const index = location.findIndex((item) => item.label === label);
    if (index !== -1) {
      keenInstanceRef.current.moveToIdx(index);
    }
  }, [label, location, keenInstanceRef]);

  const [thumbnailRef] = useKeenSlider(
    {
      initial: 0,
      slides: {
        perView: "auto",
        spacing: 8,
      },
    },
    [ThumbnailPluginCB(keenInstanceRef)]
  );

  function scaleStyleCB(idx) {
    if (!details) return {};
    const slide = details.slides[idx];
    const scale_size = 0.7;
    const scale = 1 - (scale_size - scale_size * slide.portion);
    return {
      transform: `scale(${scale})`,
      WebkitTransform: `scale(${scale})`,
    };
  }

  function ThumbnailPluginCB(mainRef) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active");
        });
      }
      function addActive(idx) {
        slider.slides[idx].classList.add("active");
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            if (mainRef.current) mainRef.current.moveToIdx(idx);
          });
        });
      }

      slider.on("created", () => {
        if (!mainRef.current) return;
        const initialIdx = mainRef.current.track.details.rel;
        addActive(initialIdx);
        addClickEvents();
        mainRef.current.on("animationStarted", (main) => {
          removeActive();
          const next = main.animator.targetIdx || 0;
          addActive(main.track.absToRel(next));
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
        });
      });
    };
  }

  return (
    <div className="travelInfo-container">
      <HeadLogo />
      <ModeIndication mode={mode} />
      <div className="travelInfo-continueBtn" onClick={onNext}>
        Continue
      </div>
      <div className="travelInfo-infoContainer">
        
        <div className="travelInfo-locationTitle">
          {mode === "time" ? "Travel Through Time: " : "Global Sites Like "}
          {title}
        </div>
        <div className="travelInfo-infoContainerCard">
          <div
            ref={sliderRef}
            className="keen-slider zoom-out travelInfo-itemContainer"
          >
            {location.map((src, idx) => (
              <div key={idx} className="keen-slider__slide zoom-out__slide">
                <div style={scaleStyleCB(idx)}>
                  <div className="travelInfo-item">
                    <img
                      src={images[src.image]}
                      className="travelInfo-img"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowModal(true);
                      }}
                    />
                    {showModal && (
                      <div
                        className="image-modal"
                        onClick={() => setShowModal(false)}
                      >
                        <img src={images[src.image]} className="full-image" />
                      </div>
                    )}
                    <div className="travelInfo-info">
                      <div className="travelInfo-year"> {src.label} </div>
                      <div className="travelInfo-title"> {src.title} </div>
                      <div className="travelInfo-description">
                        {" "}
                        {src.description}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="travelInfo-thumbnail">
            <div ref={thumbnailRef} className="keen-slider thumbnail">
              {location.map((src, idx) => {
                const isSelected = currentPeriod?.label === src.label;
                return (
                  <div key={idx} className="keen-slider__slide number-slide">
                    <div
                      className={`travelInfo-yearbth ${
                        isSelected ? "selected" : ""
                      }`}
                    >
                      {src.label}{" "}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { TravelInfoView };
